export default {
  bannerAnimatedTexts: [
    "For Global Innovators.",
    "With Scalable Software.",
    "That Drive Growth.",
    "For Ambitious Brands.",
  ],
};
